import { Box } from '@mui/material';
import { SnackbarMessage } from 'notistack';

import { type StatusChangeResult } from '../../dtos';
import { type SnackbarGenerator } from './snackbars.types';

export const generateUpdateStatusOfVeranstaltungSuccessSnackbar: SnackbarGenerator<StatusChangeResult> = (
  veranstaltung,
) => ({
  message: 'Update erfolgreich',
  options: {
    variant: 'success',
    additional: (
      <Box>
        <p>Update von Veranstaltung {veranstaltung.akaVeranstaltungId} erfolgreich. </p>
        <ul>
          {veranstaltung.successMessages.map((msg) => (
            <li key={veranstaltung.akaVeranstaltungId}>{msg}</li>
          ))}
        </ul>
      </Box>
    ),
  },
});

export const generateUpdateStatusOfVeranstaltungErrorSnackbar: SnackbarGenerator<StatusChangeResult> = (
  veranstaltung,
) => ({
  message: 'Fehler beim Ändern des Status',
  options: {
    variant: 'error',
    persist: true,
    additional: (
      <Box>
        <p>Der Status für Veranstaltung {veranstaltung.akaVeranstaltungId} konnte nicht geändert werden. </p>
        <ul>{generateFailureReasonList(veranstaltung)}</ul>
      </Box>
    ),
  },
});

const generateFailureReasonList = (veranstaltung: StatusChangeResult): SnackbarMessage => (
  <ul>
    {veranstaltung.errorMessages.map((errorMessage) => (
      <li key={`${veranstaltung.akaVeranstaltungId} - ${errorMessage}`}>{errorMessage}</li>
    ))}
  </ul>
);

export const statusChangeErrorMessage = 'Backend-Fehler beim Ändern des Status.';
